<section
  data-test-id="attachments-section"
  [class.shouldShowHeading]="'cg-margin-top-xl'"
>
  <div class="cg-margin-top-xl cg-margin-bottom-xs" *ngIf="shouldShowHeading">
    <strong>{{ 'shared.attachmentsList.title' | translate }}</strong>
  </div>
  <div
    *ngIf="(attachments$ | async)?.length; else noAttachmnets"
    class="attachments"
  >
    <div *ngFor="let attachment of attachments$ | async; let i = index">
      <button
        cignaButton="link small"
        class="cg-flush-button-link"
        [attr.data-test-id]="'attachment-name-' + i"
        (click)="onAttachmentClick(attachment)"
      >
        {{ attachment.name }}
      </button>
      <span
        *ngIf="attachment?.error"
        class="error"
        [attr.data-test-id]="'error-' + i"
      >
        <cigna-icon type="exclamation-triangle" class="error-icon"></cigna-icon>
        {{ FileUploadErrors[attachment.error] }}</span
      >
    </div>
  </div>
  <ng-template #noAttachmnets>
    <div>
      {{ 'shared.attachmentsList.noAttachments' | translate }}
    </div>
  </ng-template>
</section>
